// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidden-content {
  position: absolute;
  left: -9999px;
}


.page-break {
  page-break-before: always;
  break-before: always;
  display: block;
}

/* .firstpage {
  height: 195vh; 
  display: flex;
  flex-direction: column;
  justify-content: space-between; 
} */

.bottom-content {
  margin-top: auto; 
}

/* .secondpage {
  height: 310vh; 
  display: flex;
  flex-direction: column;
  justify-content: space-between; 
} */

.pdftable {
  /* border-collapse: separate;  */
  border-spacing: 0; 
  border-radius: 5px; 
  overflow: hidden; 
  border: 1px solid #46484b; 
}

.pdftable th, .pdftable td {
  border: 1px solid #46484b;
  padding: 8px;
  text-align: center;
}

.pdftable th {
  /* background-color: #83A4CF; */
  /* color: #fff; */
  font-size: 11px;
}


.sixthbottomcontent {
  margin-top: auto; 
}


.btn_pdf{
  background-color: #83A4CF !important;
  border-color: #83A4CF !important;
}

.btn_pdf:hover{
  background-color: #83a4cf96 !important;
  border-color: #83a4cf96 !important;
}

.btn_pdf:focus, .btn_pdf:focus-visible, .btn_pdf:focus-within, .btn_pdf:hover, .btn_pdf:visited, .btn_pdf:active, .btn_pdf:target {

  background-color: #83a4cf96 !important;
  border-color: #83a4cf96 !important;
}

.pdf-page {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  page-break-after: always;
}

.pdf-page-extra-padding {
  padding-top: 110px;
  min-height: 300px;
}

.footer {
  margin-top: auto;
}

.sixthbottomcontentnew {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.custom-plot .gtitle {
  background-color: lightblue;
}

.cont {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  background-color: #fff;
  padding: 20px;

}
.box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  background-color: #4CAF50;
  color: white;
  font-size: 20px;
  border-radius: 3px;
  /* margin: 5px;  */
}

.box-wrapper {
  display: flex;
  align-items: center;
  /* margin: 5px; */
}


.number {
  margin-left: 10px;
  font-size: 13px;
  color: #333;
}

/* .criticaltable {
  border-spacing: 0; 
  border-radius: 5px; 
  overflow: hidden; 
  border: 1px solid #46484b; 
}

.criticaltable th, .criticaltable td {
  border: 1px solid #46484b;
  padding: 8px;
  text-align: center;
}

.criticaltable th {
  font-size: 11px;
} */

.criticaltable {
  width: 100%; /* Ensure table spans full width */
  border-spacing: 0; /* Space between table cells */
  border-radius: 5px; /* Rounded corners */
  overflow: hidden; /* Ensure no overflow */
  border: 1px solid #46484b; /* Table border */
}

.criticaltable th, .criticaltable td {
  border: 1px solid #46484b; /* Border for cells */
  padding: 8px; /* Padding inside cells */
  text-align: center; /* Center align text */
}

.criticaltable th {
  font-size: 11px; /* Font size for headers */
}





`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/PDFDownload_Bus/PdfPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;AACf;;;AAGA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;;;;GAKG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;;;;;GAKG;;AAEH;EACE,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;AACjB;;;AAGA;EACE,gBAAgB;AAClB;;;AAGA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;;EAEE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,aAAa;;AAEf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;;AAGA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,WAAW,EAAE,kCAAkC;EAC/C,iBAAiB,EAAE,8BAA8B;EACjD,kBAAkB,EAAE,oBAAoB;EACxC,gBAAgB,EAAE,uBAAuB;EACzC,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,YAAY,EAAE,yBAAyB;EACvC,kBAAkB,EAAE,sBAAsB;AAC5C;;AAEA;EACE,eAAe,EAAE,0BAA0B;AAC7C","sourcesContent":[".hidden-content {\n  position: absolute;\n  left: -9999px;\n}\n\n\n.page-break {\n  page-break-before: always;\n  break-before: always;\n  display: block;\n}\n\n/* .firstpage {\n  height: 195vh; \n  display: flex;\n  flex-direction: column;\n  justify-content: space-between; \n} */\n\n.bottom-content {\n  margin-top: auto; \n}\n\n/* .secondpage {\n  height: 310vh; \n  display: flex;\n  flex-direction: column;\n  justify-content: space-between; \n} */\n\n.pdftable {\n  /* border-collapse: separate;  */\n  border-spacing: 0; \n  border-radius: 5px; \n  overflow: hidden; \n  border: 1px solid #46484b; \n}\n\n.pdftable th, .pdftable td {\n  border: 1px solid #46484b;\n  padding: 8px;\n  text-align: center;\n}\n\n.pdftable th {\n  /* background-color: #83A4CF; */\n  /* color: #fff; */\n  font-size: 11px;\n}\n\n\n.sixthbottomcontent {\n  margin-top: auto; \n}\n\n\n.btn_pdf{\n  background-color: #83A4CF !important;\n  border-color: #83A4CF !important;\n}\n\n.btn_pdf:hover{\n  background-color: #83a4cf96 !important;\n  border-color: #83a4cf96 !important;\n}\n\n.btn_pdf:focus, .btn_pdf:focus-visible, .btn_pdf:focus-within, .btn_pdf:hover, .btn_pdf:visited, .btn_pdf:active, .btn_pdf:target {\n\n  background-color: #83a4cf96 !important;\n  border-color: #83a4cf96 !important;\n}\n\n.pdf-page {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  page-break-after: always;\n}\n\n.pdf-page-extra-padding {\n  padding-top: 110px;\n  min-height: 300px;\n}\n\n.footer {\n  margin-top: auto;\n}\n\n.sixthbottomcontentnew {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.custom-plot .gtitle {\n  background-color: lightblue;\n}\n\n.cont {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  width: 100%;\n  background-color: #fff;\n  padding: 20px;\n\n}\n.box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  height: 20px;\n  background-color: #4CAF50;\n  color: white;\n  font-size: 20px;\n  border-radius: 3px;\n  /* margin: 5px;  */\n}\n\n.box-wrapper {\n  display: flex;\n  align-items: center;\n  /* margin: 5px; */\n}\n\n\n.number {\n  margin-left: 10px;\n  font-size: 13px;\n  color: #333;\n}\n\n/* .criticaltable {\n  border-spacing: 0; \n  border-radius: 5px; \n  overflow: hidden; \n  border: 1px solid #46484b; \n}\n\n.criticaltable th, .criticaltable td {\n  border: 1px solid #46484b;\n  padding: 8px;\n  text-align: center;\n}\n\n.criticaltable th {\n  font-size: 11px;\n} */\n\n.criticaltable {\n  width: 100%; /* Ensure table spans full width */\n  border-spacing: 0; /* Space between table cells */\n  border-radius: 5px; /* Rounded corners */\n  overflow: hidden; /* Ensure no overflow */\n  border: 1px solid #46484b; /* Table border */\n}\n\n.criticaltable th, .criticaltable td {\n  border: 1px solid #46484b; /* Border for cells */\n  padding: 8px; /* Padding inside cells */\n  text-align: center; /* Center align text */\n}\n\n.criticaltable th {\n  font-size: 11px; /* Font size for headers */\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
